<script>
    import { preventDefault } from 'svelte/legacy';

import {
    modalState, hideModal, showModal
} from '@app/store/modalStore.svelte.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    historyState, insertHistoryAction, resetHistory
} from '@app/store/historyStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    fade
} from 'svelte/transition';

import tcLib from '@cclib/lib/timecode.js'
import * as m from '@app/paraglide/messages.js';
eventGroupState[projectState.selected].selected.sort(); //Sort just in case
let tc = $state("00:00:00:00");
let offsetType = $state("add");
let startingIndex = $state(eventGroupState[projectState.selected].selected.length > 0 ? parseInt(eventGroupState[projectState.selected].selected[0])+1 : 1);
let endingIndex = $state(eventGroupState[projectState.selected].selected.length > 1 ? parseInt(eventGroupState[projectState.selected].selected[eventGroupState[projectState.selected].selected.length - 1])+1 : eventGroupState[projectState.selected].events.length);

if (player){
    // svelte-ignore state_referenced_locally
    let evStartTime = eventGroupState[projectState.selected].events[startingIndex-1].start || 0;
    let offsetSec = player.currentTime - evStartTime;

    if (offsetSec < 0){
        offsetType = "subtract"
    }

    tc = tcLib.secToTc(Math.abs(offsetSec), projectState.frameRate, projectState.dropFrame);
}

function applyOffset() {
    let eventIndex = parseInt(startingIndex) - 1;
    let offsetSec = tcLib.tcToSec(tc, projectState.frameRate, projectState.dropFrame);

    while (eventIndex < parseInt(endingIndex)){
        if (offsetType === "add"){
            !isNaN(eventGroupState[projectState.selected].events[eventIndex].start) ? eventGroupState[projectState.selected].events[eventIndex].start += offsetSec : null;
            
            !isNaN(eventGroupState[projectState.selected].events[eventIndex].end) ? eventGroupState[projectState.selected].events[eventIndex].end += offsetSec : null;
        } else {
            !isNaN(eventGroupState[projectState.selected].events[eventIndex].start) ? eventGroupState[projectState.selected].events[eventIndex].start -= offsetSec : null;
            
            !isNaN(eventGroupState[projectState.selected].events[eventIndex].end) ? eventGroupState[projectState.selected].events[eventIndex].end -= offsetSec : null;
        }

        eventIndex++;
    }
    
    insertHistoryAction({
        name : "apply offset", //action name
        eventGroup : projectState.selected,
        snapshots : [
            {
                store : "eventGroupState",
                value : JSON.stringify(eventGroupState)
            }
        ]
    });
    hideModal();
}

function validateTc(e) {
    tc = tcLib.tcValidate(e.target.value, projectState.frameRate, projectState.dropFrame);
}

function validateStartIndex(){
    if (startingIndex > eventGroupState[projectState.selected].events.length){
        startingIndex = eventGroupState[projectState.selected].events.length;
    }

    if (startingIndex < 1){
        startingIndex = 1;
    }    
}

function validateEndIndex(){
    if (endingIndex > eventGroupState[projectState.selected].events.length){
        endingIndex = eventGroupState[projectState.selected].events.length;
    }

    if (endingIndex < 1){
        endingIndex = 1;
    }
}

function frameByFrame(e){
    if (e.key === "ArrowUp"){
        try {
            let smpteTc = tcLib.createTc(tc, projectState.frameRate, projectState.dropFrame);
            smpteTc.add(1);
            tc = smpteTc.toString();
        } catch(e){
            console.log(e, e.message);
        }        
    } else if (e.key === "ArrowDown"){
        try {
            let smpteTc = tcLib.createTc(tc, projectState.frameRate, projectState.dropFrame);
            smpteTc.subtract(1);
            tc = smpteTc.toString();
        } catch(e){
            console.log(e, e.message);
        }
    }
}


</script>

<div transition:fade={{duration: 100}} 
    class="modal {modalState.selected === 'tcOffset' ? 'show d-block' : ''}" 
    role="dialog" 
    aria-labelledby="tcOffsetTitle"
    aria-modal="true"
    tabindex="-1" 
    id="TcOffsetModal">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="tcOffsetTitle">{m.timecode_offset()}</h4>
                <button type="button" class="btn-close" aria-label={m.close()} onclick={hideModal}></button>
            </div>
            <div class="modal-body">
                <form onsubmit={preventDefault(applyOffset)} aria-label={m.timecode_offset_form()}>
                    <div class="row">
                        <div class="col-4">
                            <div class="mb-3">
                                <label class="form-label" id="offsetTypeLabel" for="offsetTypeSelect">{m.offset_type()}</label>
                                <select class="form-select" id="offsetTypeSelect" bind:value={offsetType} aria-labelledby="offsetTypeLabel">
                                    <option value="add">{m.add()}</option>
                                    <option value="subtract">{m.subtract()}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col">
                            <div class="mb-3">
                                <label class="form-label" id="offsetLabel" for="offsetInput">{m.offset()}</label>
                                <input class="form-control" 
                                    id="offsetInput"
                                    type="text" 
                                    placeholder={m.smpte_format_placeholder()} 
                                    bind:value={tc} 
                                    onblur={validateTc} 
                                    onkeydown={frameByFrame} 
                                    onfocus={(e)=>{e.target.select()}}
                                    aria-labelledby="offsetLabel">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="mb-3">
                                <label class="form-label" for="startingEventId">{m.starting_event_id()}</label>
                                <input class="form-control" id="startingEventId" type="number" min="1" step="1" max={eventGroupState[projectState.selected].events.length} placeholder={m.starting_event_id()} bind:value={startingIndex} onblur={validateStartIndex}>
                            </div>
                        </div>
                        <div class="col">
                            <div class="mb-3">
                                <label class="form-label" for="endingEventId">{m.ending_event_id()}</label>
                                <input class="form-control" id="endingEventId" type="number" min="1" step="1" max={eventGroupState[projectState.selected].events.length} placeholder={m.ending_event_id()} bind:value={endingIndex} onblur={validateEndIndex}>
                            </div>
                        </div>
                    </div>
                    
                    
                    
                    <button class="btn btn-primary float-end" 
                        id="applyOffsetBtn"
                        type="button" 
                        onclick={applyOffset}
                        aria-label={m.apply_timecode_offset()}>{m.apply_offset()}</button>
                </form>
            </div>
        </div>
    </div>
</div>
